export enum ConsumerLoanLogMessageDeliveryStatus {
    Queued,
    Sent,
    Delivered,
    Failed
}
